import { createActions } from 'reduxsauce';
const { Types, Creators } = createActions({
  fetchTicketDetail: ['isTicket', 'params', 'loading'],
  fetchTicketDetailSuccess: ['data'],
  fetchTicketDetailFail: [],
  fetchAttachmentsTicket: ['ticketId', 'isINCTicket', 'requestItemId'],
  fetchAttachmentsTicketSuccess: ['data'],
  fetchAttachmentsTicketFail: [],
  fetchActivities: ['isTicket', 'ticketId'],
  fetchActivitiesSuccess: ['data'],
  fetchActivitiesFail: [],
  provideComment: ['isTicket', 'ticketId', 'user_name', 'keyComment', 'activeTab', 'requestItemId', 'ticketNumber', 'user_id'],
  ticketPostAttachment: ['isTicket', 'ticketId', 'files', 'activeTab','ticketNumber', 'user_id', 'user_name', 'requestItemId'],
  ticketPostAttachmentSuccess: ['data'],
  ticketPostAttachmentFail: ['data'],
  setErrors: ['data', 'override'],

});
export const TicketDetailTypes = Types;
export default Creators;